const convertToModel = (data = [], Model) =>
  data.map((item) => new Model({ ...item }));

export default convertToModel;
